import { dew as _rangeDew } from "../classes/range";
var exports = {},
  _dewExec = false;
export function dew() {
  if (_dewExec) return exports;
  _dewExec = true;
  const Range = _rangeDew();

  // Mostly just for testing and legacy API reasons
  const toComparators = (range, options) => new Range(range, options).set.map(comp => comp.map(c => c.value).join(" ").trim().split(" "));
  exports = toComparators;
  return exports;
}